



















































































































































































import {Component, Emit, Inject, Prop, Watch} from "vue-property-decorator";
import PersonMarker from "../PersonMarker.vue";
import UserEdit from "../useredit/UserEdit.vue";
import RoleAdd from "../role-add/RoleAdd.vue";
import UserMerge from "../usermerge/UserMerge.vue";
import AddPhoneDialog from "../add-phone-dialog/AddPhoneDialog.vue";
import ConfirmPhoneDialog from "../add-phone-dialog/ConfirmPhoneDialog.vue";
import HmsCardDisplay from "../HmsCardDisplay.vue";
import MergeUndoDialog from "./MergeUndoDialog.vue";
import Api from "./Api";
import {
    ApiMessage,
    CardUserdata,
    Company, DateTime, EmailAddress, IdCard, LastIn,
    PhoneNumber,
    Role,
    RolesForCompany,
    RolesForLocation,
    TerminalLocation
} from "../../modules/models";
import UserRequired from "../UserRequired";
import ArrowInIcon from "@/components/sio/ArrowInIcon.vue";
import {ErrorColor, InfoColor, UnimportantColor} from "@/modules/constants";
import Ellipsifier from "@/components/shared/Ellipsifier.vue";
import rd from "@/modules/vRoutedefs";
import {RoleAddData} from "@/components/role-add/RoleAdd.vue";
import InfoDialog from "@/components/InfoDialog.vue";
import AddEmailDialog from "@/components/user-card/AddEmailDialog.vue";

@Component({
    components: {
        "at-person-marker": PersonMarker,
        "at-user-edit": UserEdit,
        "at-role-add": RoleAdd,
        "at-user-merge": UserMerge,
        "at-add-phone": AddPhoneDialog,
        "at-confirm-phone": ConfirmPhoneDialog,
        "at-card-display": HmsCardDisplay,
        "at-undoinfo": MergeUndoDialog,
        "at-arrow-in": ArrowInIcon,
        "at-ellip": Ellipsifier,
        "at-info": InfoDialog,
        "at-add-email": AddEmailDialog,
    }
})
export default class UserCard extends UserRequired {
    @Inject()
    api!: Api;

    readonly unimportantColor = UnimportantColor;

    @Prop({default: null})
    activeCompany!: Company | null;

    @Prop({default: null})
    personProp!: CardUserdata | null;

    @Prop({default: false})
    userOverviewDisplay!: boolean;

    @Prop({default: false})
    triggerEmailAdd!: boolean;

    get personData(): CardUserdata | null {
        return this.personProp;
    }
    get personGuid() {
        return this.personData && this.personData.person ? this.personData.person.guid : null;
    }

    get isLoggedInPerson(): boolean {
        return !!this.personData && this.personData.person.guid == this.user.person.guid;
    }
    get hasMultiplePhones() {
        return this.personData && this.personData.phoneNumbers.length > 1
    }
    get hasActiveCards() {
        const now = DateTime.now();
        return this.personData != null && this.personData.cards.some((c: IdCard) => c.deactivated == null || !c.deactivated.isBefore(now));
    }
    get canRemovePhone() {
        return this.isLoggedInPerson && (this.hasMultiplePhones || this.hasActiveCards);
    }
    get canEdit() {
        if(this.personData != null) {
            const orgnum = this.personData.person.companyOrgnum;
            return !this.personData.isVerified() && (
                this.isLoggedInPerson ||
                !orgnum ||
                this.user.isCompanyAdmin(orgnum) ||
                this.user.isCompanySuper(orgnum)
            );
        }
        return false;
    }

    locationRoleTxt(r: Role, l: TerminalLocation): string {
        return `${r.typename} på ${l.description}`;
    }

    locationRolesJoin(lrs: RolesForLocation[]): string[] {
        const strs: string[] = [];
        for(let lr of lrs) {
            for(let r of lr.roles) {
                strs.push(this.locationRoleTxt(r, lr.location));
            }
        }
        return strs;
    }

    rolesCommaTxt(rfc: RolesForCompany): string {
        const companyRolesTxt = rfc.companyRoles.map((r) => r.typename);
        const locationRolesTxt = this.locationRolesJoin(rfc.locationRoles);
        const all = companyRolesTxt.concat(locationRolesTxt);
        return all.join(", ");
    }

    roleAddOpened = false;
    openRoleAdd() {
        this.roleAddOpened = true;
    }

    addingRole = false;
    async onRoleAdd(data: RoleAddData) {
        this.addingRole = true;
        try {
            await this.api.addUserRole(data.orgNum, data.personGuid, data.roleid, data.locid);
            this.$emit("at-user-role-added");
        } catch (e) {
            this.emitError(e);
        } finally {
            this.addingRole = false;
        }
    }

    openUserEdit() {
        if(this.personData != null) {
            const el = this.$refs.userEdit;
            if (el instanceof UserEdit) {
                const dlg = el as UserEdit;
                dlg.open(this.personData.person, this.personData.employedAt);
            }
        } else {
            throw new Error("missing personData");
        }
    }

    async removeCompanyRole(orgNum: number, roleId: number) {
        if(this.personData != null) {
            await this.api.removeUserRole(orgNum, this.personData.person.guid, roleId, null);
            this.$emit("at-user-role-removed");
        }
    }

    async removeLocationRole(orgNum: number, locid: number, roleId: number) {
        if(this.personData != null) {
            await this.api.removeUserRole(orgNum, this.personData.person.guid, roleId, locid);
            this.$emit("at-user-role-removed");
        }
    }

    userMergeOpened = false;

    isUndoingMerge = false;
    async undoMerge(undoTxid: number) {
        this.showUndoInfo = false;
        this.isUndoingMerge = true;
        try {
            await this.api.undoPersonMerge(undoTxid);
            this.$emit("at-user-unmerged");
        } catch(err) {
            this.emitError(err);
        } finally {
            this.isUndoingMerge = false;
        }
    }

    // Phone removal
    phoneToRemove: PhoneNumber | null = null;
    cancelRemovePhone() {
        this.phoneToRemove = null;
    }
    // User must confirm removal since it might affect login session
    showRemovePhoneConfirm(phone: PhoneNumber) {
        this.phoneToRemove = phone;
    }

    showRemovedPhone = false;
    async removePhone() {
        const phone = this.phoneToRemove;
        if(phone != null) {
            this.phoneToRemove = null;
            this.removePhoneTxid = await this.api.removeSelfPhone(phone);
            this.baseApi.loadUser(); // Refresh user info, which is the same as displayed person when phone removal is possible
            this.showRemovedPhone = true;
        }
    }
    removePhoneTxid = 0;
    showUndoneRemovedPhone = false;
    async undoRemovedPhone() {
        await this.api.undoRemoveSelfPhone(this.removePhoneTxid);
        this.baseApi.loadUser(); // Refresh user info
        this.showUndoneRemovedPhone = true;
    }

    showAddPhone = false;
    pendingPhoneAdded: PhoneNumber | null = null;
    get showPendingPhoneInfo() {
        return this.pendingPhoneAdded != null;
    }
    set showPendingPhoneInfo(v: boolean) {
        if(!v) {
            this.pendingPhoneAdded = null;
        }
    }
    async onAddPhone(p: PhoneNumber) {
        if(this.personData != null) {
            const msg = await this.api.addPersonPhone(this.personData.person.guid, p);
            if (msg.num == 16) {
                this.pendingPhoneAdded = p;
                this.emitUserSaved();
            } else if (msg.num === 58 || msg.num === 59) { // user not admin for this person
                this.apiMsg = msg;

            } else { // Error message was returned
                this.emitError(new Error(msg.msg));
            }
        } else {
            throw new Error("Missing personData");
        }
    }
    async onPhoneConfirmed(apiMsg: ApiMessage) {
        this.apiMsg = apiMsg;
        this.emitUserSaved(); // Trigger data refresh
    }

    async removePendingPhone(p: PhoneNumber) {
        if(this.personData != null) {
            await this.api.removePendingPhone(this.personData.person.guid, p);
            this.emitUserSaved();
        } else {
            throw new Error("Missing personData");
        }
    }

    confirmPhone: PhoneNumber | null = null;
    get showConfirmPhone() {
        return this.confirmPhone != null;
    }
    set showConfirmPhone(v: boolean) {
        if(!v) {
            this.confirmPhone = null;
        }
    }
    showConfirmDlg(p: PhoneNumber) {
        this.confirmPhone = p;
        this.pendingPhoneAdded = null;
    }
    apiMsg: ApiMessage | null = null;
    get showApiMsg() {
        return this.apiMsg != null;
    }
    set showApiMsg(v: boolean) {
        if(!v) {
            this.apiMsg = null;
        }
    }
    printGuid() {
        if(this.personData != null) {
            console.info(`person guid for ${this.personData.person.name}: ${this.personData.person.guid}`);
        }
    }

    showUndoInfo = false;

    lastIn: LastIn | null = null;

    @Watch("personGuid", {immediate: true})
    async loadLastIn() {
        if(this.personGuid != null) {
            this.lastIn = await this.api.getLastIn(this.personGuid);
        } else {
            this.lastIn = null;
        }
    }

    // TODO: Implement direct link to sitereport at given location + date/time
    lastInTo() {
        if(this.lastIn) {
            return {
                name: rd.locations.location.name,
                params: {locationId: this.lastIn.terminalLocation.id}
            }
        }
        return {name: rd.locations.name};
    }

    // Re-emit for parent
    @Emit("at-user-edit-saved")
    emitUserSaved() {}

    // Re-emit for parent
    onUserMerged(d) {
        this.$emit("at-user-merged", d);
    }

    showEmailConfirmInfo = false;
    showAddEmail = false;
    waitingEmailEdit = false;

    async onAddEmail(email: string) {
        if(this.personData != null) {
            this.waitingEmailEdit = true;
            try {
                const msg = await this.api.addPersonEmail(this.personData.person.guid, email);
                this.emitUserSaved(); // Trigger refresh
                if(msg.num === 201) {
                    this.emitSnack(`Bekreftelses-epost sendt til ${email}`);
                } else if(msg.num === 200) {
                    this.emitSnack(`"${email} er IKKE en gyldig epostadresse. Prøv igjen og kontroller inntasting`, ErrorColor);
                } else if(msg.num == 202) {
                    this.emitSnack(`Grense for antall epost tilknytninger pr dag er nådd. Prøv igjen i morgen.`, ErrorColor);
                } else {
                    this.emitError(new Error(msg.msg));
                }
            } finally {
                this.waitingEmailEdit = false;
            }
        }
    }

    async removePendingEmail(id: number) {
        this.waitingEmailEdit = true;
        try {
            await this.api.removePendingPersonEmail(id);
            this.emitUserSaved(); // Trigger refresh
            this.emitSnack(`Ubekreftet epostadresse fjernet`);
        } finally {
            this.waitingEmailEdit = false;
        }
    }
    async removeEmail(id: number) {
        this.waitingEmailEdit = true;
        try {
            await this.api.removePersonEmail(id);
            this.emitUserSaved(); // Trigger refresh
            this.undoRemoveEmailId = id;
            this.showUndoRemoveEmail = true;
        } finally {
            this.waitingEmailEdit = false;
        }
    }
    undoRemoveEmailId: number | null = null;
    showUndoRemoveEmail = false;
    async undoRemoveEmail() {
        if (this.undoRemoveEmailId != null) {
            this.waitingEmailEdit = true;
            try {
                const undone = await this.api.undoRemovePersonEmail(this.undoRemoveEmailId);
                if (undone) {
                    this.emitUserSaved(); // Trigger refresh
                    this.emitSnack(`Epostadresse gjenopprettet`);
                } else {
                    this.emitError(new Error(`Epostadresse kunne ikke gjenopprettes. Ukjent årsak.`));
                }
            } finally {
                this.waitingEmailEdit = false;
            }
        }
    }

    created() {
      if(this.triggerEmailAdd) {
        this.showAddEmail = true;
      }
    }
}
